// src/components/form/IAITextarea.jsx
import React, { useState, useCallback } from 'react';
import { useField } from 'react-final-form';
import { Button } from '@spark/ui-components/components/Button';
import { notification } from '@spark/ui-components/utils/notification';
import { defaultParams } from '@spark/services';
import { melhorarTexto } from '@spark/services/recrutamento-rh';

const IAITextarea = ({
  name,
  label = 'Descrição da Vaga (detalhada)',
  placeholder = 'Detalhes, responsabilidades…',
  disabled = false,
  readOnly = false,
  type = 'text',
  rows = 2,
}) => {
  const { input, meta } = useField(name);
  const [loading, setLoading] = useState(false);

  const handleImprove = useCallback(async () => {
    const txt = String(input.value || '').trim();
    if (!txt) {
      notification.warning('Digite algo antes de melhorar com IA.');
      return;
    }
    try {
      setLoading(true);
      const { improvedText } = await melhorarTexto(txt, defaultParams());
      input.onChange(improvedText);
      notification.success('Texto melhorado com sucesso!');
    } catch (err) {
      notification.error(err?.message || 'Falha ao melhorar texto.');
    } finally {
      setLoading(false);
    }
  }, [input]);

  const isDisabled = disabled || readOnly || loading;
  const InputTag = type === 'textarea' ? 'textarea' : 'input';

  return (
    <div className="form-group">
      {label && (
        <label htmlFor={name} className="form-label" style={{ fontWeight: 600 }}>
          {label}
        </label>
      )}

      <div className="input-group" style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
        <InputTag
          id={name}
          name={name}
          type={type === 'textarea' ? undefined : type}
          className="form-control"
          placeholder={placeholder}
          value={input.value || ''}
          onChange={input.onChange}
          onBlur={input.onBlur}
          onFocus={input.onFocus}
          disabled={isDisabled}
          readOnly={readOnly}
          rows={type === 'textarea' ? rows : undefined}
          aria-label={label}
          style={{ width:'100%', backgroundColor: '#fff',}}
        />
        {!readOnly && (
          <div className="input-group-append">
            <Button
              variant="ghost"
              type="button"
              onClick={handleImprove}
              disabled={isDisabled}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '8px 14px',
                borderRadius: '999px',
                fontWeight: 600,
                background: loading
                  ? 'linear-gradient(90deg, #007AFF 0%, #00C4FF 100%)'
                  : 'linear-gradient(90deg, #6A5ACD 0%, #00BFFF 100%)',
                color: '#fff',
                border: 'none',
                transition: 'all 0.3s ease',
                boxShadow: loading
                  ? '0 0 12px rgba(0, 196, 255, 0.5)'
                  : '0 0 6px rgba(0, 196, 255, 0.3)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 0 16px rgba(0, 196, 255, 0.8)';
                e.currentTarget.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = loading
                  ? '0 0 12px rgba(0, 196, 255, 0.5)'
                  : '0 0 6px rgba(0, 196, 255, 0.3)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: '#fff' }}
                  />
                  <span>Processando…</span>
                </>
              ) : (
                <>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 2v20M2 12h20" opacity="0.5" />
                    <path d="M9 9h6v6H9z" />
                  </svg>
                  <span>Melhorar com IA</span>
                </>
              )}
            </Button>

          </div>
        )}
      </div>

      {meta.touched && meta.error ? (
        <div className="text-danger" style={{ marginTop: 6 }}>{meta.error}</div>
      ) : null}
    </div>
  );
};

export default IAITextarea;
